import React from 'react';
import logo_pop from '../assets/images/logo-pop.png';
import { Link } from 'react-router-dom';
import EDSFooter from '../components/EDSFooter';

const Rejestracja_potwierdzenie = () => {
    return (
        <>
            <header className="header">
                <div className="header__image-box">
                    <a href="">
                        <img
                            src={logo_pop}
                            alt="Logo Egurrola Dance Studio"
                            className="header__image"
                        />
                    </a>
                </div>
                <div className="header__caption-box">
                    <span className="header__caption">Proces zakupu kursu</span>
                </div>
            </header>
            <div className="content">
                <div className="half-half--reverse margin-top-64">
                    <main>
                        <section>
                            <h2 className="h2">Potwierdź konto</h2>
                            <p className="margin-top-32">
                                Na podany w formularzu adres mailowy wysłaliśmy wiadomość. Aby
                                uzyskać dostęp do Portalu Klienta kliknij w link aktywacyjny z maila
                                i potwierdź chęć założenia konta.
                            </p>
                            <Link to="/">
                                <a href="" className="btn-primary-responsive margin-top-64">
                                    Przejdź do strony logowania
                                </a>
                            </Link>
                            <p className="margin-top-32">
                                Nie dostałeś/łaś naszej wiadomości? Sprawdź foldery{' '}
                                <span className="fw-700">spamu i poczty masowej</span>.
                            </p>
                        </section>
                    </main>
                    <div className="decorative">
                        <svg viewBox="0 0 320 320" xmlns="http://www.w3.org/2000/svg">
                            <path d="M310 89.825C310 39.445 279.94 10 229.235 10C194.765 10 87.11 45.94 65.905 53.13C30.26 62.82 10 93.925 10 135.435V215.265L146.765 238.565V304.295L188.05 310L217.805 281.49V219.41L310 163.945V89.825ZM19.375 135.435C19.375 88.47 46.74 59.29 90.775 59.29C138.435 59.29 167.94 104.735 167.94 146.845V232.665L19.375 207.355V135.435ZM156.14 296.13V240.165L177.315 243.77L178.675 242.95V299.245L156.14 296.13ZM250.125 63.02L197.29 83.035L197.335 170.615L184.535 176.915V40.085L250.16 17.535L250.125 63.02Z" />
                            <path d="M48.03 155.01L41.1 114.695L28.95 113.06L28.51 163.075L36.295 164.13L36.6 130.29C36.61 129.32 36.61 127.955 36.61 126.2C36.6 124.445 36.61 123.095 36.62 122.14L43.76 165.125L51.88 166.225L59.82 125.275C59.81 126.225 59.79 127.575 59.755 129.325C59.725 131.085 59.7 132.435 59.69 133.405L59.395 167.245L67.175 168.29L67.615 118.285L55.6 116.65L48.03 155.01Z" />
                            <path d="M86.77 120.85L72.07 168.945L80.8 170.125L83.595 160.21L98.315 162.19L100.865 172.83L109.92 174.055L96.225 122.135L86.77 120.85ZM85.94 151.9L91.295 132.92L96.17 153.28L85.94 151.9Z" />
                            <path d="M114.315 174.64L122.605 175.765L123.045 125.75L114.755 124.635L114.315 174.64Z" />
                            <path d="M139.21 127.93L130.86 126.8L130.42 176.815L158.72 180.625L158.8 171.635L138.855 168.945L139.21 127.93Z" />
                            <path d="M82.335 104.39C88.64 103.725 95.785 98.8101 96.515 89.4451L101.745 87.0351C107.405 84.4301 102.77 73.2551 97.115 75.8701L93.74 77.4301C91.045 73.1001 86.74 70.5051 82.06 71.0001C80.07 71.2101 77.895 72.0301 76.42 72.6751L76.31 72.7251C75.335 73.1601 74.685 73.5001 74.685 73.5001L74.69 73.5551C69.955 76.3301 66.995 82.6051 67.725 89.5951C68.655 98.5151 75.195 105.13 82.335 104.39Z" />
                        </svg>
                    </div>
                </div>
            </div>
            <EDSFooter></EDSFooter>
        </>
    );
};
export default Rejestracja_potwierdzenie;
